import { render, staticRenderFns } from "./NurseAideAdd.vue?vue&type=template&id=65c23a12&scoped=true&"
import script from "./NurseAideAdd.vue?vue&type=script&lang=js&"
export * from "./NurseAideAdd.vue?vue&type=script&lang=js&"
import style0 from "./NurseAideAdd.vue?vue&type=style&index=0&id=65c23a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c23a12",
  null
  
)

export default component.exports